import { render, staticRenderFns } from "./ColoredStatus.vue?vue&type=template&id=a8acb6ae&scoped=true"
import script from "./ColoredStatus.vue?vue&type=script&lang=js"
export * from "./ColoredStatus.vue?vue&type=script&lang=js"
import style0 from "./ColoredStatus.vue?vue&type=style&index=0&id=a8acb6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8acb6ae",
  null
  
)

export default component.exports